export enum RedirectConstants {
  Title = 'Opening external page',
  Subtitle = 'You are being redirected to an external page. Ensure you trust the page before clicking the link to continue.',
}
